import { action, atom } from '@reatom/framework'

import type { UserShort } from '@root/entities/user-short'

export const reportUserFlowAtom = atom<
  { user: UserShort.UserShort } | undefined
>(undefined, 'reportUserFlowAtom')

export const startReportUserFlowAction = action(
  (ctx, params: { user: UserShort.UserShort }) => {
    reportUserFlowAtom(ctx, params)
  },
  'startReportUserFlowAction',
)
